module.exports = __webpack_public_path__ + "media/country_flags/mq-6c730aea.png";